import styled from 'styled-components';

import { PortfolioSummaryProvider } from '#/features/account/portfolio-summary-context';
import { PortfolioSearchParamsProvider } from '#/features/navigation/portfolio-context';

import PortfolioOverview from './PortfolioOverview';

export default function Portfolio() {
  return (
    <PortfolioSearchParamsProvider>
      <PortfolioSummaryProvider>
        <PortfolioContent />
      </PortfolioSummaryProvider>
    </PortfolioSearchParamsProvider>
  );
}

function PortfolioContent() {
  return (
    <Container>
      <PortfolioOverview />
    </Container>
  );
}

const Container = styled.div`
  flex-grow: 1;
  padding: 0px 24px;
  width: 100%;
  overflow: scroll; /* avoid jumpy layout when container becomes scrollable */
`;
